import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { exitImpersonation } from "../slices/authSlice";
import { useNavigate } from "react-router-dom";
import { EyeOutlined, CloseOutlined } from "@ant-design/icons";

// The banner is fixed to the top of the window, so layouts under it offset
// their content by this height while impersonating.
export const IMPERSONATION_BANNER_HEIGHT = 40;

// Beside a sidebar the banner starts clear of the collapsed rail. Above the
// top bar nothing sits to its left, so `fullWidth` spans the whole window.
const ImpersonationBanner = ({ fullWidth = false }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isImpersonating, impersonatedUserEmail } = useSelector(
    (state) => state.auth
  );

  if (!isImpersonating) return null;

  const handleExit = async () => {
    await dispatch(exitImpersonation());
    // The in-web admin was retired (→ apps/admin); return to the app home.
    navigate("/");
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: fullWidth ? 0 : 60,
        right: 0,
        height: IMPERSONATION_BANNER_HEIGHT,
        backgroundColor: "#F59E0B",
        color: "#111827",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 51,
        fontFamily: "Inter, sans-serif",
        fontSize: 14,
        fontWeight: 500,
        gap: 8,
      }}
    >
      <EyeOutlined style={{ fontSize: 16 }} />
      <span>
        Viewing as <strong>{impersonatedUserEmail}</strong>
        <span style={{ fontWeight: 400, opacity: 0.85 }}>
          {" "}— read-only view; changes are disabled
        </span>
      </span>
      <button
        onClick={handleExit}
        style={{
          position: "absolute",
          right: 16,
          display: "flex",
          alignItems: "center",
          gap: 4,
          background: "rgba(0,0,0,0.15)",
          border: "none",
          borderRadius: 4,
          padding: "4px 12px",
          cursor: "pointer",
          fontFamily: "Inter, sans-serif",
          fontSize: 13,
          fontWeight: 600,
          color: "#111827",
        }}
      >
        <CloseOutlined style={{ fontSize: 12 }} />
        Exit
      </button>
    </div>
  );
};

export default ImpersonationBanner;
